module.exports = __webpack_public_path__ + "static/img/virus1.5772c507.png";